export const DocumentIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Document Icon</title>
      <path
        d="M5.55566 9.02783H7.639"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55566 11.8055H11.1112"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77783 6.25003H7.63894V1.38892"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.69339 1.38892H12.5001C13.2671 1.38892 13.8889 2.01074 13.8889 2.7778V13.8889C13.8889 14.656 13.2671 15.2778 12.5001 15.2778H4.16672C3.39966 15.2778 2.77783 14.656 2.77783 13.8889V6.30449C2.77783 5.93613 2.92416 5.58287 3.18463 5.3224L6.71131 1.79571C6.97179 1.53524 7.32505 1.38892 7.69339 1.38892Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
